// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingInvoicePaymentResponse

import { BillingPaymentStatus } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingInvoicePaymentApiResponse = {
	id: number;
	amount: number;
	status: BillingPaymentStatus;
	date: string;
	paymentIntentId: string | null;
	errorCode: string | null;
};

export type BillingInvoicePayment = {
	id: number;
	amount: number;
	status: BillingPaymentStatus;
	date: DateTime;
	paymentIntentId: string | null;
	errorCode: string | null;
};

export function hydrateBillingInvoicePayment(data: BillingInvoicePaymentApiResponse): BillingInvoicePayment {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
	};
}